import { GetSyncConfig, getSyncUrl } from 'api/HightouchAPI';
import { addNegativeToastWithErrorId } from 'modules/toastContainer';
import { ReactNode } from 'react';
import { useDispatch } from 'react-redux';
import { OverflowMenu } from 'ui/actionMenu';
import { AllowedActionMenuElements } from 'ui/actionMenu/types';
import { Edit16, TimeClock16 } from 'ui/icons';

export const TABLE_OVERFLOW_MENU_TEXT = {
  menuId: 'table-overflow-menu',
  runLabel: 'View run history',
  runId: 'run',

  configurationLabel: 'Edit',
  configurationId: 'configuration',
};

const Content = ({ Icon, children }: { Icon: ReactNode; children: ReactNode }) => (
  <>
    {Icon}
    <span>{children}</span>
  </>
);

type TableOverflowMenuProps = {
  id: number;
};

export const TableOverflowMenu = ({ id }: TableOverflowMenuProps) => {
  const dispatch = useDispatch();

  const handleClick = (config: GetSyncConfig) =>
    getSyncUrl({
      config,
      onSuccess: ({ data }) => {
        window.open(data.url, '_blank', 'popup,width=1080,height=600');
      },
      onError: (error) => {
        // Error handled on Hightouch side, more for network errors
        dispatch(
          addNegativeToastWithErrorId(
            'Trouble getting sync config.',
            'SmartIngestTableOverflowMenu',
            error,
          ),
        );
      },
      syncId: id,
    });

  return (
    <OverflowMenu
      id={TABLE_OVERFLOW_MENU_TEXT.menuId}
      options={[
        {
          as: AllowedActionMenuElements.Button,
          content: (
            <Content Icon={<Edit16 />}>{TABLE_OVERFLOW_MENU_TEXT.configurationLabel}</Content>
          ),
          id: TABLE_OVERFLOW_MENU_TEXT.configurationId,
          onClick: () => handleClick(GetSyncConfig.Configuration),
        },
        {
          as: AllowedActionMenuElements.Button,
          content: <Content Icon={<TimeClock16 />}>{TABLE_OVERFLOW_MENU_TEXT.runLabel}</Content>,
          id: TABLE_OVERFLOW_MENU_TEXT.runId,
          onClick: () => handleClick(GetSyncConfig.Runs),
        },
      ]}
    />
  );
};
